import React, { Fragment, useState } from "react";

import { ReactComponent as ClientSecret } from "@common/assets/images/client-secret-icon.svg";
import Dropdown, { DropdownItem } from "@common/components/Dropdown/Dropdown";
import { CellEnd, CenteredCell } from "@common/components/GridTable/GridTable";
import Paragraph from "@common/components/Paragraph/Paragraph";
import displayToast from "@common/components/Toast/displayToast";
import { ApiKey, ApiKeyType, getTypeAsText } from "@common/models/ApiKey.model";
import { vars } from "@common/styles";
import identifiers from "@common/util/identifiers.json";
import { format } from "date-fns";

import * as Styled from "./ApiKeyRow.styles";

interface Props {
  setSelectedApiKey: (apiKey: ApiKey) => void;
  toggleDelete: () => void;
  apiKey: ApiKey;
  isAdmin: boolean;
}

export const ApiKeyRow = ({ setSelectedApiKey, toggleDelete, apiKey, isAdmin }: Props) => {
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  const handleClick = () => {
    if (!apiKey) return;
    navigator.clipboard.writeText(apiKey.key);
    const message =
      apiKey.type === ApiKeyType.API ? "REST API key copied to clipboard" : "App API key copied to clipboard";
    displayToast({
      content: message,
    });
    setIsDropdownOpened(false);
  };

  return (
    <Fragment>
      <CenteredCell
        minWidth="100"
        maxWidth="400"
      >
        <ClientSecret />
        <span onDoubleClick={handleClick}>
          <Paragraph color={vars.colors.grey30}>{apiKey.key}</Paragraph>
        </span>
      </CenteredCell>
      <CenteredCell>
        <Styled.RowTag
          color={getTypeColor(apiKey.type)}
          value={getTypeAsText(apiKey.type)}
          border
          borderColor={vars.colors.grey90}
        />
      </CenteredCell>
      <CenteredCell>
        <Paragraph>Created {format(new Date(apiKey.created), "MMM dd, yyyy")}</Paragraph>
      </CenteredCell>
      <CellEnd>
        <Dropdown
          isOpened={isDropdownOpened}
          setIsOpened={setIsDropdownOpened}
        >
          <DropdownItem
            onClick={handleClick}
            testId={identifiers["general.dropdownButton.copy"]}
          >
            Copy
          </DropdownItem>
          {isAdmin && (
            <DropdownItem
              onClick={() => {
                setSelectedApiKey(apiKey);
                toggleDelete();
                setIsDropdownOpened(false);
              }}
              error
            >
              Delete
            </DropdownItem>
          )}
        </Dropdown>
      </CellEnd>
    </Fragment>
  );
};

export const getTypeColor = (type: ApiKeyType) => {
  switch (type) {
    case ApiKeyType.API:
      return vars.colors.lavender;
    default:
      return vars.colors.green;
  }
};
